import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFolders12 from './IconFolders12';
import IconFolders16 from './IconFolders16';
import IconFolders20 from './IconFolders20';
import IconFolders24 from './IconFolders24';
import IconFolders32 from './IconFolders32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFolders = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFolders12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFolders16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFolders20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFolders24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFolders32 {...props} />}
        </span>
    );
};
IconFolders.displayName = 'FondueIconFolders';

export default memo(IconFolders);
